import { styled, css } from 'styled-components';
import { DEFAULT_BORDER_WIDTH } from '../../common';
import { colors } from '../../../../abstracts';
import { dontForwardProps } from '../../../../util';
const StyledListItem = styled.li.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1atkt82-0"
})(["", ";align-items:flex-start;display:inline-grid;grid-template-columns:", ";gap:0.5rem;"], ({
  hasDivider,
  hasDividers,
  isHorizontal
}) => (hasDivider || hasDividers) && !isHorizontal && css(["padding-bottom:1.5rem !important;margin-bottom:1.5rem;border-bottom:", " solid ", ";"], DEFAULT_BORDER_WIDTH, colors.neutralBrightest), ({
  hasIcons
}) => hasIcons ? '1.5rem 1fr' : '1fr');
export { StyledListItem };